import Grid from '@mui/material/Grid2';
import StorageIcon from '@mui/icons-material/Storage';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import VerifiedIcon from '@mui/icons-material/Verified';

const METRICS = [
  {
    Icon: StorageIcon,
    label: "Registro estructurado de información crítica",
  },
  {
    number: "100%",
    label: "Trazabilidad por material",
  },
  {
    Icon: FilterAltIcon,
    label: "Eliminación de duplicidades",
  },
  {
    Icon: VerifiedIcon,
    label: "Mayor confiabilidad en reportes",
  },
];

function ImpactSection() {
  return (
    <section className="bg-[#EFF6FF]">
      <div className="max-w-[1200px] mx-auto py-96 px-40 text-center">
        <h2 className="text-40 font-extrabold text-[#1E3A8A] mb-20 leading-[1.2]">
          Resultados que generan confianza
        </h2>
        <p className="text-20 text-[#475569] max-w-[780px] mx-auto mb-64 leading-[1.8]">
          Empresas que usan EcoRep logran mayor control, reducción de errores y respaldo técnico en sus procesos de gestión ambiental.
        </p>
        <Grid container spacing={3}>
          {METRICS.map(({ Icon, number, label }) => (
            <Grid key={label} size={{ xs: 12, sm: 6, md: 3 }}>
              <div
                className="bg-white rounded-16 py-44 px-28 h-full flex flex-col items-center text-center shadow-[0_2px_16px_rgba(26,86,219,0.08)] transition-[transform,box-shadow] duration-200 ease-out hover:-translate-y-[4px] hover:shadow-[0_8px_24px_rgba(26,86,219,0.14)]"
                style={{ borderTop: '4px solid #1A56DB' }}
              >
                {Icon && <Icon className="!text-52 text-[#1A56DB] mb-16" />}
                {number && (
                  <span className="block text-52 font-black text-[#1A56DB] leading-none mb-16">
                    {number}
                  </span>
                )}
                <p className="text-18 font-semibold text-[#1E3A8A] leading-[1.5] m-0">{label}</p>
              </div>
            </Grid>
          ))}
        </Grid>
      </div>
    </section>
  );
}

export default ImpactSection;
